<template>
  <div class="base-info-add">
    <div class="table-container" style="padding: 0">
      <TableCommon title="基本信息" :show-custome="false">
        <div class="form-container" style="padding: 0">
          <el-form inline size="mini" label-width="100px" :model="formModel" :rules="rules">
            <el-row :gutter="24">
              <el-col :lg="8" :md="12">
                <el-form-item label="客户编码">
                  <el-input v-model="wlyClientPo.PARTNER" placeholder="系统自动生成" disabled/>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item prop="NAME_ORG1" label="客户名称" required>
                  <el-input v-model="wlyClientPo.NAME_ORG1" placeholder="请输入客户名称" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item prop="ZZFLD000016" label="客户类型" required>
                  <el-select v-model="wlyClientPo.ZZFLD000016" placeholder="请选择客户类型" clearable>
                    <el-option
                      v-for="item in selectDataOptions.A0009"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="法人姓名">
                  <el-input v-model="wlyClientPo.ZZFLD000018" placeholder="请输入法人姓名" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="法人电话">
                  <el-input v-model="wlyClientPo.ZZFLD000019" placeholder="请输入法人电话" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="营销管理编码">
                  <el-input v-model="wlyClientPo.ZZFLD00001C" placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="旧编码">
                  <el-input v-model="wlyClientPo.ZZFLD000017" placeholder="请输入旧编码" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="上级客户编码">
                  <wly-input
                    ref="superiorBpInput"
                    :key="`superior-bp-${wlyClientPo.SUPERIOR_BP || 'empty'}`"
                    v-model="wlyClientPo.SUPERIOR_BP"
                    input-type="customer"
                    clearable
                    @enter="handleSuperiorClientEnter"
                    @handleSuffixClick="openSuperiorClientDialog"
                    @input="handleSuperiorClientInput"
                    @clear="handleSuperiorClientClear"
                    @keydown.native="handleSuperiorClientKeydown"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="上级客户名称">
                  <el-input v-model="wlyClientPo.SUPERIOR_BP_NAME" placeholder="系统自动代入" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="曾用名编码">
                  <wly-input
                    ref="formerBpInput"
                    :key="`former-bp-${wlyClientPo.FORMER_BP || 'empty'}`"
                    v-model="wlyClientPo.FORMER_BP"
                    input-type="customer"
                    clearable
                    @enter="handleFormerClientEnter"
                    @handleSuffixClick="openFormerClientDialog"
                    @input="handleFormerClientInput"
                    @clear="handleFormerClientClear"
                    @keydown.native="handleFormerClientKeydown"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="曾用名名称">
                  <el-input v-model="wlyClientPo.FORMER_BP_NAME" placeholder="系统自动代入" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item prop="TAX.TAXNUMXL" label="税号">
                  <el-input v-model="TAX.TAXNUMXL" placeholder="请输入税号" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item prop="TAX.TAXTYPE" label="发票类型">
                  <el-select v-model="TAX.TAXTYPE" placeholder="请选择" clearable>
                    <el-option
                      v-for="item in selectDataOptions.A0032"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="工商登记号">
                  <el-input v-model="wlyClientPo.ZZFLD00001B" :disabled="!$_has(['WLY004', 'WLYALL'])" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="社会信用代码" class="line-16">
                  <el-input v-model="wlyClientPo.ZZFLD00001A" placeholder="请输入社会信用代码" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="片区">
                  <el-select v-model="wlyClientPo.PQ_REGION" placeholder="请选择片区" clearable>
                    <el-option
                      v-for="item in selectDataOptions.A0085"
                      :key="item.value"
                      :label="item.name"
                      :value="item.name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </TableCommon>

      <slot name="bank" />

      <TableCommon title="营销单元" required>
        <template #button>
          <table-button name="add" tip="新增" @click="insertSaleCenter" />
          <table-button name="delete" tip="删除" @click="removeSaleCenter" />
        </template>
        <vxe-grid
          ref="xTableSaleCenter"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="400"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :toolbar-config="{ custom: false }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="saleCenterGridOptions.columns"
          :data="saleCenterGridOptions.data"
        >
          <template #ZZFLD00001H="{ row }">
            <el-select
              v-model="row.ZZFLD00001H"
              size="mini"
              placeholder="请选择营销单元"
              @change="handleSaleCenterChange(row)"
            >
              <el-option
                v-for="item in selectDataOptions.orgList"
                :key="item.SOBID"
                :label="item.MC_SHORT"
                :value="item.SOBID"
              />
            </el-select>
          </template>
          <template #ZZFLD00003E="{ row }">
            <el-select
              v-model="row.ZZFLD00003E"
              size="mini"
              placeholder="请选择基地"
            >
              <el-option
                v-for="item in row.baseList"
                :key="item.SOBID"
                :label="item.MC_SHORT"
                :value="item.SOBID"
              />
            </el-select>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="地址信息" required :custome-config="() => vxeShowCustom('xTable3')">
        <template #button>
          <table-button name="add" tip="新增" @click="insertAddressList" />
          <table-button name="delete" tip="删除" @click="removeAddressList" />
        </template>
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="240"
          align="center"
          size="mini"
          :edit-rules="validRules"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          :columns="gridOptions3.columns"
          :data="gridOptions3.data"
          @edit-actived="editActived"
        >
          <template #ADR_KIND="{row}">
            <span>{{ row.ADR_KIND_TEXT }}</span>
          </template>
          <template #REGION="{row}">
            <span>{{ row.BEZEI }}</span>
          </template>
          <template #CITY_CODE="{ row }">
            <span>{{ row.CITY_NAME }}</span>
          </template>
          <template #STREETCODE="{row}">
            <span>{{ row.STREET_NAME }}</span>
          </template>

          <template #ADR_KIND_edit="{row}">
            <vxe-select
              v-model="row.ADR_KIND"
              type="text"
              size="mini"
              transfer
              @change="addressTypeChange($event, row)"
            >
              <vxe-option
                v-for="selectItem in selectDataOptions['A0099']"
                :key="selectItem.value"
                :label="selectItem.name"
                :value="selectItem.value"
              />
            </vxe-select>
          </template>
          <template #C_O_NAME_edit="{row, rowIndex}">
            <el-input
              v-model="row.C_O_NAME"
              size="mini"
              @paste.native="pasteInput($event, 'C_O_NAME', row, rowIndex)"
            />
          </template>
          <template #BUILDING_edit="{row, rowIndex}">
            <el-input
              v-model="row.BUILDING"
              size="mini"
              @paste.native="pasteInput($event, 'BUILDING', row, rowIndex)"
            />
          </template>
          <template #TELNR_LONG_edit="{row, rowIndex}">
            <el-input
              v-model="row.TELNR_LONG"
              size="mini"
              @paste.native="pasteInput($event, 'TELNR_LONG', row, rowIndex)"
            />
          </template>
          <template #TEL_NUMBER_edit="{row, rowIndex}">
            <el-input
              v-model="row.TEL_NUMBER"
              size="mini"
              @paste.native="pasteInput($event, 'TEL_NUMBER', row, rowIndex)"
            />
          </template>
          <template #FAX_NUMBER_edit="{row, rowIndex}">
            <el-input
              v-model="row.FAX_NUMBER"
              size="mini"
              @paste.native="pasteInput($event, 'FAX_NUMBER', row, rowIndex)"
            />
          </template>
          <template #REGION_edit="{row}">
            <vxe-select
              v-model="row.REGION"
              size="mini"
              transfer
              @change="changeRegion($event, row)"
            >
              <vxe-option
                v-for="selectItem in selectDataOptions['province']"
                :key="selectItem.BLAND"
                :label="selectItem.BEZEI"
                :value="selectItem.BLAND"
              />
            </vxe-select>
          </template>
          <template #CITY_CODE_edit="{ row }">
            <vxe-select
              v-model="row.CITY_CODE"
              size="mini"
              transfer
              type="text"
              @change="changeCity($event, row)"
            >
              <vxe-option
                v-for="selectItem in selectDataOptions['city']"
                :key="selectItem.CITY_CODE"
                :label="selectItem.CITY_NAME"
                :value="selectItem.CITY_CODE"
              />
            </vxe-select>
          </template>
          <template #STREETCODE_edit="{ row }">
            <vxe-select
              v-model="row.STREETCODE"
              size="mini"
              transfer
              @change="changeStreet($event, row)"
            >
              <vxe-option
                v-for="selectItem in selectDataOptions['street']"
                :key="selectItem.STRT_CODE"
                :label="selectItem.MC_STREET"
                :value="selectItem.STRT_CODE"
              />
            </vxe-select>
          </template>
          <template #STREET_edit="{row, rowIndex}">
            <el-input
              v-model="row.STREET"
              size="mini"
              @paste.native="pasteInput($event, 'STREET', row, rowIndex)"
            />
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 上级客户选择弹窗 -->
    <el-dialog
      v-dialogDrag
      title="上级客户选择"
      :visible.sync="showSuperiorClientDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showSuperiorClientDialog">
        <client-select ref="superiorClientSelect" />
      </template>
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showSuperiorClientDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="submitSuperiorClient"
        >确认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-dialogDrag
      title="曾用名选择"
      :visible.sync="showFormerClientDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showFormerClientDialog">
        <client-select ref="formerClientSelect" />
      </template>
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showFormerClientDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="submitFormerClient"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { getArea, apiGetOrgOrBase } from '@/api/sap/common-sap'
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')

export default {
  name: 'BaseInfoAdd',
  components: {
    ClientSelect
  },
  props: {
    clientData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const rules = {
      NAME_ORG1: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
      ZZFLD000016: [{ required: true, message: '请选择客户类型', trigger: 'change' }]
    }
    return {
      rules,
      wlyClientPo: {},
      TAX: {},
      superiorBpOriginalValue: '', // 保存上级客户编码的原始值
      formerBpOriginalValue: '', // 保存曾用名编码的原始值
      selectDataOptions: {
        A0009: [],
        A0032: [],
        A0064: [],
        A0099: [],
        A0085: [],
        province: [],
        city: [],
        street: [],
        orgList: []
      },
      showSuperiorClientDialog: false,
      showFormerClientDialog: false,
      validRules: {
        ADR_KIND: [{ required: true, trigger: 'manual' }],
        REGION: [{ required: true, trigger: 'manual' }],
        CITY_CODE: [{ required: true, trigger: 'manual' }],
        STREETCODE: [{ required: true, trigger: 'manual' }],
        STREET: [{ required: true, trigger: 'manual' }]
      },
      gridOptions3: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          {
            field: 'ADR_KIND',
            title: '地址类型',
            width: 100,
            slots: { default: 'ADR_KIND', edit: 'ADR_KIND_edit' },
            editRender: {}
          },
          {
            field: 'C_O_NAME',
            title: '联系人',
            width: 80,
            slots: { edit: 'C_O_NAME_edit' },
            editRender: {}
          },
          {
            field: 'BUILDING',
            title: '身份证号',
            width: 140,
            slots: { edit: 'BUILDING_edit' },
            editRender: {}
          },
          {
            field: 'TELNR_LONG',
            title: '电话',
            width: 100,
            slots: { edit: 'TELNR_LONG_edit' },
            editRender: {}
          },
          {
            field: 'TEL_NUMBER',
            title: '手机',
            width: 100,
            slots: { edit: 'TEL_NUMBER_edit' },
            editRender: {}
          },
          {
            field: 'FAX_NUMBER',
            title: '电子邮箱',
            width: 80,
            slots: { edit: 'FAX_NUMBER_edit' },
            editRender: {}
          },
          {
            field: 'REGION',
            title: '省',
            width: 80,
            slots: { default: 'REGION', edit: 'REGION_edit' },
            editRender: {}
          },
          {
            field: 'CITY_CODE',
            title: '市',
            width: 80,
            slots: { default: 'CITY_CODE', edit: 'CITY_CODE_edit' },
            editRender: {}
          },
          {
            field: 'STREETCODE',
            title: '区',
            width: 80,
            slots: { default: 'STREETCODE', edit: 'STREETCODE_edit' },
            editRender: {}
          },
          {
            field: 'STREET',
            title: '地址',
            width: 385,
            slots: { edit: 'STREET_edit' },
            editRender: {}
          }
        ],
        data: [],
        delData: []
      },
      saleCenterGridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'ZZFLD00001H', title: '营销单元', minWidth: 160, slots: { default: 'ZZFLD00001H' } },
          { field: 'ZZFLD00003E', title: '基地', minWidth: 160, slots: { default: 'ZZFLD00003E' } }
        ],
        data: []
      }
    }
  },
  computed: {
    formModel() {
      return {
        ...this.wlyClientPo,
        TAX: this.TAX
      }
    }
  },
  created() {
    this.init()
    this.applyClientData(this.clientData)
  },
  watch: {
    'clientData.INFO': {
      deep: true,
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.wlyClientPo = { ...val }
        } else {
          this.wlyClientPo = {}
        }
      }
    },
    'clientData.TAX': {
      deep: true,
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.TAX = { ...val }
        } else {
          this.TAX = {}
        }
      }
    },
    'clientData.ADDRESS': {
      deep: true,
      handler(val) {
        if (val && Array.isArray(val)) {
          this.gridOptions3.data = val.map(item => ({
            ...item
          }))
        } else {
          this.gridOptions3.data = []
        }
      }
    },
    'clientData.YXDY': {
      deep: true,
      handler(val) {
        if (val && Array.isArray(val) && val.length > 0) {
          this.saleCenterGridOptions.data = val.map(item => ({
            ...item,
            baseList: []
          }))
          this.initSaleCenterBaseList()
        } else {
          this.saleCenterGridOptions.data = []
        }
      }
    }
  },
  methods: {
    async init() {
      await Promise.all([
        this.loadDict('A0009'),
        this.loadDict('A0032'),
        this.loadDict('A0064'),
        this.loadDict('A0099'),
        this.loadDict('A0085')
      ])
      try {
        const { DATA } = await getArea('', 'region')
        this.selectDataOptions.province = DATA || []
      } catch (e) {
        this.selectDataOptions.province = []
      }
      await this.fetchOrgList()
    },
    async loadDict(code) {
      const formData = new FormData()
      formData.append('code', code)
      try {
        const res = await apiLoadDictionaryDtl(formData)
        this.$set(this.selectDataOptions, code, res.data.Rows || [])
      } catch (e) {
        this.$set(this.selectDataOptions, code, [])
      }
    },
    applyClientData(data = {}) {
      this.wlyClientPo = { ...(data.INFO || {}) }
      this.TAX = { ...(data.TAX || {}) }
      // 初始化上级客户编码的原始值
      this.superiorBpOriginalValue = this.wlyClientPo.SUPERIOR_BP || ''
      this.formerBpOriginalValue = this.wlyClientPo.FORMER_BP || ''
      this.gridOptions3.data = (data.ADDRESS || []).map(item => ({
        ...item
      }))
      this.saleCenterGridOptions.data = (data.YXDY || []).map(item => ({
        ...item,
        baseList: []
      }))
      this.initSaleCenterBaseList()
      this.gridOptions3.delData = []
    },
    async fetchOrgList() {
      try {
        const { DATA } = await apiGetOrgOrBase('', 1)
        this.selectDataOptions.orgList = DATA || []
      } catch (e) {
        this.selectDataOptions.orgList = []
      }
    },
    insertSaleCenter() {
      this.saleCenterGridOptions.data.unshift({
        ZZFLD00001H: '',
        ZZFLD00003E: '',
        baseList: []
      })
    },
    removeSaleCenter() {
      const $table = this.$refs.xTableSaleCenter
      if (!$table) return
      const checked = $table.getCheckboxRecords()
      if (!checked.length) {
        this.$message.warning('请选择要删除的营销单元')
        return
      }
      checked.forEach(row => {
        const index = this.saleCenterGridOptions.data.indexOf(row)
        if (index !== -1) {
          this.saleCenterGridOptions.data.splice(index, 1)
        }
      })
    },
    async handleSaleCenterChange(row) {
      if (!row.ZZFLD00001H) {
        row.baseList = []
        row.ZZFLD00003E = ''
        return
      }
      try {
        const { DATA } = await apiGetOrgOrBase(row.ZZFLD00001H, 2)
        row.baseList = DATA || []
        if (!row.baseList.some(item => item.SOBID === row.ZZFLD00003E)) {
          row.ZZFLD00003E = ''
        }
      } catch (e) {
        row.baseList = []
        row.ZZFLD00003E = ''
      }
    },
    async initSaleCenterBaseList() {
      const tasks = this.saleCenterGridOptions.data.map(async row => {
        if (!row.ZZFLD00001H) {
          row.baseList = []
          return
        }
        try {
          const { DATA } = await apiGetOrgOrBase(row.ZZFLD00001H, 2)
          row.baseList = DATA || []
        } catch (e) {
          row.baseList = []
        }
      })
      await Promise.all(tasks)
    },
    // 新增地址信息
    insertAddressList() {
      const columns = this.gridOptions3.columns.filter(v => !v.type)
      const data = {}
      columns.forEach(v => (data[v.field] = ''))
      this.gridOptions3.data.unshift(data)
    },
    // 删除地址信息
    removeAddressList() {
      const $table = this.$refs.xTable3
      if (!$table) return
      const checkedList = $table.getCheckboxRecords()
      if (!checkedList.length) {
        this.$message.warning('请选择要删除的地址信息')
        return
      }
      const hasGuids = checkedList.filter(v => v.GUID)
      this.gridOptions3.delData = hasGuids
      checkedList.forEach(item => {
        const index = this.gridOptions3.data.findIndex(v => v._X_ID === item._X_ID)
        if (index !== -1) {
          this.gridOptions3.data.splice(index, 1)
        }
      })
    },
    editActived({ column, row }) {
      if (column.property === 'CITY_CODE') {
        if (row.REGION) {
          getArea(row.REGION, 'city').then(res => {
            this.$set(this.selectDataOptions, 'city', res.DATA)
          })
        } else {
          this.selectDataOptions.city = []
        }
      } else if (column.property === 'STREETCODE') {
        if (row.CITY_CODE) {
          getArea(row.CITY_CODE, 'street').then(res => {
            this.$set(this.selectDataOptions, 'street', res.DATA)
          })
        } else {
          this.selectDataOptions.street = []
        }
      }
    },
    // 粘贴地址
    pasteInput(e, field, row, rowIndex) {
      const pasteFields = [
        'C_O_NAME',
        'BUILDING',
        'TELNR_LONG',
        'TEL_NUMBER',
        'FAX_NUMBER',
        'REGION',
        'CITY_CODE',
        'STREETCODE',
        'STREET'
      ]
      if (!pasteFields.includes(field)) return
      e.preventDefault()
      const paste = (e.clipboardData || window.clipboardData).getData('text')
      const rows = paste.split('\n').filter(v => v)
      if (rows.length > 1) {
        rows.forEach((r, i) => {
          if (this.gridOptions3.data[i + rowIndex]) {
            const values = r.split('\t')
            pasteFields.forEach((f, idx) => {
              if (values[idx] && this.gridOptions3.data[i + rowIndex]) {
                this.gridOptions3.data[i + rowIndex][f] = values[idx].trim()
              }
            })
          }
        })
      } else {
        row[field] = paste.trim()
      }
    },
    addressTypeChange(e, row) {
      if (e.value === 'BILL_TO') {
        const has = this.gridOptions3.data.filter(v => v.ADR_KIND === 'BILL_TO')
        if (has.length > 1) {
          row.ADR_KIND = ''
          row.ADR_KIND_TEXT = ''
          return this.$message.error('不能改为开票地址！')
        }
      }
      row['ADR_KIND_TEXT'] =
        this.selectDataOptions['A0099'].find(v => v.value === e.value)?.name || ''
    },
    async changeRegion(e, row) {
      // 获取描述字段
      row.BEZEI = this.selectDataOptions.province.find(v => v.BLAND === e.value)?.BEZEI || ''
      row.CITY_CODE = ''
      row.CITY_NAME = ''
      row.STREETCODE = ''
      row.STREET_NAME = ''
      const { DATA } = await getArea(e.value, 'city')
      this.$set(this.selectDataOptions, 'city', DATA)
      this.$set(this.selectDataOptions, 'street', [])
    },
    async changeCity(e, row) {
      row.CITY_NAME =
        this.selectDataOptions.city.find(v => v.CITY_CODE === e.value)?.CITY_NAME || ''
      row.STREETCODE = ''
      row.STREET_NAME = ''
      const { DATA } = await getArea(e.value, 'street')
      this.$set(this.selectDataOptions, 'street', DATA)
    },
    changeStreet(e, row) {
      row.STREET_NAME =
        this.selectDataOptions.street.find(v => v.STRT_CODE === e.value)?.MC_STREET || ''
    },
    isBusinessLicenseAddress(row) {
      if (!row) return false
      const text = String(row.ADR_KIND_TEXT || '')
      if (text.includes('营业执照')) {
        return true
      }
      return false
    },
    // 验证地址信息
    validateAddress() {
      try {
        const keys = Object.keys(this.validRules)
        this.gridOptions3.data.forEach((row, i) => {
          for (const key of keys) {
            if (!row[key]) {
              throw new Error('请输入地址信息必输项！')
            }
          }
          if (this.isBusinessLicenseAddress(row) && !row.STREET) {
            throw new Error(`地址信息:第${i + 1}行营业执照地址需填写详细地址！`)
          }
          const regCard = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
          if (row.BUILDING && !regCard.test(row.BUILDING)) {
            throw new Error(`地址信息:第${i + 1}行` + '身份证格式不正确！')
          }
          const regPhone = /^1[3|4|5|7|8][0-9]{9}$/
          if (row.TEL_NUMBER && !regPhone.test(row.TEL_NUMBER)) {
            throw new Error(`地址信息:第${i + 1}行` + '手机号格式不正确！')
          }
          const regTel = /^(\d{3,4}-)?[0-9]{7,8}$/
          if (row.TELNR_LONG && !regTel.test(row.TELNR_LONG)) {
            throw new Error(`地址信息:第${i + 1}行` + '电话号格式不正确！')
          }
        })
        return true
      } catch (e) {
        this.$message.error(e.message)
        return false
      }
    },
    radioChange(val, type) {
      if (val === 'X') {
        const date = this.$utilsCommon
          ? this.$utilsCommon.parseTime(new Date().getTime(), '{y}{m}{d}')
          : ''
        if (type === 1) {
          this.wlyClientPo.ZZFLD000026_DATE = date
        } else {
          this.wlyClientPo.BLOCK_DATE = date
        }
      } else {
        if (type === 1) {
          this.wlyClientPo.ZZFLD000026_DATE = ''
          this.wlyClientPo.REMARK_GD = ''
        } else {
          this.wlyClientPo.BLOCK_DATE = ''
          this.wlyClientPo.REMARK_BLK = ''
        }
      }
    },
    submitForm() {
      // 验证必填项：客户名称
      if (!this.wlyClientPo.NAME_ORG1) {
        this.$message.error('请输入客户名称')
        return null
      }
      // 验证必填项：客户类型
      if (!this.wlyClientPo.ZZFLD000016) {
        this.$message.error('请选择客户类型')
        return null
      }
      // 验证必填项：营销单元
      if (!this.saleCenterGridOptions.data || this.saleCenterGridOptions.data.length === 0) {
        this.$message.error('请至少添加一个营销单元')
        return null
      }
      // 验证营销单元必填字段
      const invalidSaleCenter = this.saleCenterGridOptions.data.find(item => !item.ZZFLD00001H)
      if (invalidSaleCenter) {
        this.$message.error('请完善营销单元信息')
        return null
      }
      // 验证必填项：地址信息
      if (!this.validateAddress()) {
        return null
      }
      const saleCenterData = this.saleCenterGridOptions.data.map(({ baseList, ...rest }) => rest)
      return {
        INFO: this.wlyClientPo,
        TAX: this.TAX,
        ADDRESS: this.gridOptions3.data,
        ADDRESS_D: this.gridOptions3.delData,
        YXDY: saleCenterData,
        PRO: [],
        HISTORY: [],
        TYPE_HISTORY: []
      }
    },
    vxeShowCustom(ref) {
      return () => {
        this.$refs[ref]?.showCustom()
      }
    },
    // 打开上级客户选择弹窗
    openSuperiorClientDialog(event) {
      // 阻止事件冒泡，防止触发其他事件
      if (event) {
        event.stopPropagation()
        event.preventDefault()
      }
      // 保存当前值，防止在打开弹窗时被清空
      const currentValue = this.wlyClientPo.SUPERIOR_BP || ''
      this.superiorBpOriginalValue = currentValue
      this.showSuperiorClientDialog = true
    },
    // 提交上级客户选择
    submitSuperiorClient() {
      this.$refs.superiorClientSelect.submitForm().then(res => {
        if (res) {
          this.wlyClientPo.SUPERIOR_BP = res.partner
          this.wlyClientPo.SUPERIOR_BP_NAME = res.name_org1
          this.superiorBpOriginalValue = res.partner // 更新原始值
          this.showSuperiorClientDialog = false
        }
      })
    },
    // 上级客户输入框回车事件
    // 处理上级客户编码键盘按下事件，阻止手动输入
    handleSuperiorClientKeydown(event) {
      // 允许删除键、退格键、Tab键、方向键、Ctrl/Cmd组合键等
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Escape']
      // 允许 Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X 等组合键
      if (event.ctrlKey || event.metaKey) {
        return
      }
      // 如果按下的键不在允许列表中，阻止输入
      if (!allowedKeys.includes(event.key) && !event.key.startsWith('F')) {
        event.preventDefault()
        event.stopPropagation()
      }
    },
    // 处理上级客户编码清除事件
    handleSuperiorClientClear() {
      // 清空编码和名称
      // v-model 已经通过 @input 事件更新了 SUPERIOR_BP，这里只需要清空名称和原始值
      this.$set(this.wlyClientPo, 'SUPERIOR_BP_NAME', '')
      this.superiorBpOriginalValue = ''
      // 确保编码也被清空（双重保险）
      this.$set(this.wlyClientPo, 'SUPERIOR_BP', '')
      // 强制更新视图
      this.$forceUpdate()
    },
    // 处理上级客户编码输入
    handleSuperiorClientInput(value) {
      // 如果是清空操作，清空名称和原始值
      if (!value || value === '') {
        this.$set(this.wlyClientPo, 'SUPERIOR_BP_NAME', '')
        this.superiorBpOriginalValue = ''
        // 确保编码也被清空
        if (this.wlyClientPo.SUPERIOR_BP !== '') {
          this.$set(this.wlyClientPo, 'SUPERIOR_BP', '')
        }
        return
      }

      const currentValue = String(value || '')
      const originalValue = String(this.superiorBpOriginalValue || '')

      // 如果是手动输入（值变化了且不是清空操作），阻止并恢复原值
      if (currentValue !== '' && currentValue !== originalValue && originalValue !== '') {
        // 恢复原值
        this.$nextTick(() => {
          if (this.wlyClientPo.SUPERIOR_BP !== originalValue) {
            this.wlyClientPo.SUPERIOR_BP = originalValue
          }
        })
        return
      }

      // 更新原始值（允许通过选择操作更新）
      if (currentValue === originalValue || originalValue === '') {
        this.superiorBpOriginalValue = currentValue
      }
    },
    handleSuperiorClientEnter(e, type, data) {
      if (typeof type === 'object') {
        this.$message.error(type.message)
        return
      }
      if (!data) return
      this.wlyClientPo.SUPERIOR_BP = data.partner
      this.wlyClientPo.SUPERIOR_BP_NAME = data.name_org1
      this.superiorBpOriginalValue = data.partner // 更新原始值
    },
    // 打开曾用名选择弹窗
    openFormerClientDialog(event) {
      if (event) {
        event.stopPropagation()
        event.preventDefault()
      }
      const currentValue = this.wlyClientPo.FORMER_BP || ''
      this.formerBpOriginalValue = currentValue
      this.showFormerClientDialog = true
    },
    // 提交曾用名选择
    submitFormerClient() {
      this.$refs.formerClientSelect.submitForm().then(res => {
        if (res) {
          this.wlyClientPo.FORMER_BP = res.partner
          this.wlyClientPo.FORMER_BP_NAME = res.name_org1
          this.formerBpOriginalValue = res.partner
          this.showFormerClientDialog = false
        }
      })
    },
    handleFormerClientKeydown(event) {
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Escape']
      if (event.ctrlKey || event.metaKey) {
        return
      }
      if (!allowedKeys.includes(event.key) && !event.key.startsWith('F')) {
        event.preventDefault()
        event.stopPropagation()
      }
    },
    handleFormerClientClear() {
      this.$set(this.wlyClientPo, 'FORMER_BP_NAME', '')
      this.formerBpOriginalValue = ''
      this.$set(this.wlyClientPo, 'FORMER_BP', '')
      this.$forceUpdate()
    },
    handleFormerClientInput(value) {
      if (!value || value === '') {
        this.$set(this.wlyClientPo, 'FORMER_BP_NAME', '')
        this.formerBpOriginalValue = ''
        if (this.wlyClientPo.FORMER_BP !== '') {
          this.$set(this.wlyClientPo, 'FORMER_BP', '')
        }
        return
      }
      const currentValue = String(value || '')
      const originalValue = String(this.formerBpOriginalValue || '')
      if (currentValue !== '' && currentValue !== originalValue && originalValue !== '') {
        this.$nextTick(() => {
          if (this.wlyClientPo.FORMER_BP !== originalValue) {
            this.wlyClientPo.FORMER_BP = originalValue
          }
        })
        return
      }
      if (currentValue === originalValue || originalValue === '') {
        this.formerBpOriginalValue = currentValue
      }
    },
    handleFormerClientEnter(e, type, data) {
      if (typeof type === 'object') {
        this.$message.error(type.message)
        return
      }
      if (!data) return
      this.wlyClientPo.FORMER_BP = data.partner
      this.wlyClientPo.FORMER_BP_NAME = data.name_org1
      this.formerBpOriginalValue = data.partner
    }
  }
}
</script>

<style scoped>
.base-info-add .form-container {
  padding: 0 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/client-manage/components/BaseInfoAdd.vue